<template>
	<j-base-select
		:id="id"
		:options="options"
		:value="value"
		:status="status"
		:size="size"
		:allowSelectNothing="false"
		@input="onInput($event)"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
	/>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import { currencies } from "@/forms/enums.js"

export default {
	components: { JBaseSelect },
	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true,
			default: null
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		}
	},
	computed: {
		options() {
			return currencies
		}
	},
	methods: {
		onInput(value) {
			this.$emit("input", value)
		}
	}
}
</script>
